
	import { BaseTLTableComponent, AxiosResponse, Component, PersonService, PersonFilter, Prop } from "../../../Infrastructure/CorBase/CoreBase";


export default abstract class  PersonListBase extends BaseTLTableComponent {
		selectedPersonId: number = 0;
		PersonService: PersonService = new PersonService();

		@Prop({ type: Boolean, required: false, default: false }) isShowModal!: boolean; //zobrazení v modálním dialogu


		setFields() {
			this.fields = [
				{ key: 'personalNumber', label: this.$t('person.fieldPersonalNumber'), trans: this.$t('person.fieldPersonalNumber'), sortable: true, class: 'text-left' },
				{ key: 'lastName', label: this.$t('person.fieldLastName'), trans: this.$t('person.fieldLastName'), sortable: true, class: 'text-left' },
				{ key: 'firstName', label: this.$t('person.fieldFirstName'), trans: this.$t('person.fieldFirstName'), sortable: true, class: 'text-left' },
				{ key: 'idWorkingGroupNavigationNames', label: this.$t('person.fieldTurnus'), trans: this.$t('person.fieldTurnus'), sortable: false, class: 'text-left' },
			]
			if (this.isShowModal == false) {
				this.fields.push({ key: 'actions', label: this.$t('person.fieldActions'), trans: this.$t('person.fieldActions'), sortable: false, class: 'text-left' });
			}
		};

		//filtry
		setfilters(value: any) {
			if (value != null) {
				this.filters = value;
			}
			else {
				this.filters = [
					{ key: 'personalNumber', label: this.$t('person.fieldPersonalNumber'), trans: this.$t('person.fieldPersonalNumber'), selected: false, value: null, type: 'text' },
					{ key: 'lastName', label: this.$t('person.fieldLastName'), trans: this.$t('person.fieldLastName'), selected: false, value: null, type: 'text' },
					{ key: 'firstName', label: this.$t('person.fieldFirstName'), trans: this.$t('person.fieldFirstName'), selected: false, value: null, type: 'text' },
					{ key: 'idWorkingGroupNavigationNames', label: this.$t('person.fieldTurnus'), trans: this.$t('person.fieldTurnus'), selected: false, value: null, type: 'text' },
				];
			}
		}

		fetchDataFromServer(): Promise<AxiosResponse<any>> {
			let personFilter: PersonFilter = new PersonFilter(null, this.$store.state.idTenant, false);
			return this.PersonService.getAllByFilter(personFilter);
		}

		//zatím nepotrebujeme
		fetchRefreshDataFromServer(): Promise<AxiosResponse<any>> {
			return this.fetchDataFromServer();
		}

		refreshItems(items: any[], refreshData: any[]) {
			return items;
		}

		prepareItems(items: any[]) {
			// zde zatim nepotrebujeme
			for (var i = 0; i < items.length; i++) {
				if (items[i].corUserCreationDate != null) {
					items[i].corUserCreationDate = new Date(items[i].corUserCreationDate).toLocaleDateString();
				}
			}
		}

		// VaP - toto zde musi byt, jinak nefunguje napojeni na tabulku
	
		//detailClick(PersonId: any) {
	
			
		//	//Původni az se to uplne rozpohybuje tak se zjisti
		//	//if (this.isShowModal) {
		//	//	let person = this.tableData.filter(c => c.id == Number(PersonId))[0];
		//	//	this.$emit('selectItem', person);
		//	//}
		//	//else if (this.hasRight) {
		//	//	this.$router.push({ name: "PersonDetail", params: { id: PersonId, type: "details" } });
		//	//}
		//};
	

	};